"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resources = void 0;
const store_1 = require("../storage/store");
const service_1 = require("../mesh/service");
const Identity_1 = require("../data/identity/Identity");
const peer_1 = require("../mesh/agents/peer");
const linkup_1 = require("../net/linkup");
const backends_1 = require("../storage/backends");
const random_1 = require("../crypto/random");
const identity_1 = require("../data/identity");
class Resources {
    constructor(init) {
        var _a;
        const linkupServers = ((_a = init === null || init === void 0 ? void 0 : init.config) === null || _a === void 0 ? void 0 : _a.linkupServers) !== undefined && init.config.linkupServers.length > 0 ?
            init.config.linkupServers
            :
                [linkup_1.LinkupManager.defaultLinkupServer];
        this.config = {
            linkupServers: linkupServers,
            id: init.config.id
        };
        if (init.store === undefined) {
            this.store = new store_1.Store(new backends_1.MemoryBackend('auto-generated store ' + new random_1.RNGImpl().randomHexString(64)));
        }
        else {
            this.store = init === null || init === void 0 ? void 0 : init.store;
        }
        if (init.mesh === undefined) {
            this.mesh = new service_1.Mesh();
        }
        else {
            this.mesh = init.mesh;
        }
        if (init.config.peersForDiscovery !== undefined &&
            init.config.endpointParserForDiscovery !== undefined) {
            this.config.peersForDiscovery = init.config.peersForDiscovery;
            this.config.endpointParserForDiscovery = init.config.endpointParserForDiscovery;
        }
        else {
            this.config.peersForDiscovery = [(new peer_1.IdentityPeer(linkupServers[0], this.config.id.hash(), this.config.id)).asPeerIfReady()];
            this.config.endpointParserForDiscovery = peer_1.IdentityPeer.getEndpointParser(this.store);
        }
        this.aliasing = new Map();
    }
    getId() {
        if (this.config.id === undefined) {
            throw new Error('A default identity was requested, but none was provided in the resources object.');
        }
        return this.config.id;
    }
    getPeersForDiscovery() {
        if (this.config.peersForDiscovery === undefined) {
            throw new Error('A list of peers for discovery was requested, but none was provided in the resources object.');
        }
        return this.config.peersForDiscovery;
    }
    getEndointParserForDiscovery() {
        if (this.config.endpointParserForDiscovery === undefined) {
            throw new Error('An endpoint parser for discovery was requested, but none was provided in the resources object.');
        }
        return this.config.endpointParserForDiscovery;
    }
    static async create(init) {
        var _a, _b, _c, _d;
        let localId;
        if (((_a = init === null || init === void 0 ? void 0 : init.config) === null || _a === void 0 ? void 0 : _a.id) !== undefined) {
            localId = init === null || init === void 0 ? void 0 : init.config.id;
        }
        else {
            let key = await identity_1.RSAKeyPair.generate(1024);
            localId = Identity_1.Identity.fromKeyPair({ name: 'auto-generated id ' + new random_1.RNGImpl().randomHexString(64) }, key);
        }
        const config = {
            linkupServers: (_b = init === null || init === void 0 ? void 0 : init.config) === null || _b === void 0 ? void 0 : _b.linkupServers,
            id: localId,
            peersForDiscovery: (_c = init === null || init === void 0 ? void 0 : init.config) === null || _c === void 0 ? void 0 : _c.peersForDiscovery,
            endpointParserForDiscovery: (_d = init === null || init === void 0 ? void 0 : init.config) === null || _d === void 0 ? void 0 : _d.endpointParserForDiscovery
        };
        return new Resources({ store: init === null || init === void 0 ? void 0 : init.store, mesh: init === null || init === void 0 ? void 0 : init.mesh, config: config, aliasing: init === null || init === void 0 ? void 0 : init.aliasing });
    }
}
exports.Resources = Resources;
//# sourceMappingURL=Resources.js.map